import ApiService from "../ApiService";
const { REACT_APP_REST_ENDPOINT } = process.env;

export default class AttestatiService {
  
  static generaAttestato = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/attestati/genera`;
      ApiService.postRequest(resolve, reject, url, data)
    });
  };

  static downloadAttestato = (data, filename) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/attestati/download`;

      // L'ApiService si occuperà di chiamare il backend e gestire il download
      ApiService.postRequestWithDownload(resolve, reject, url, {
        ...data,
        filename: filename
      });
    });
  };

  static stampaBusta = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/attestati/stampa-busta`;
      const filename = `busta_spedizione_${data.id_attestato}.pdf`;

      // Riusiamo la stessa logica di download per la busta
      ApiService.postRequestWithDownload(resolve, reject, url, {
        ...data,
        filename: filename,
      });
    });
  };

  static aggiornaSpedizione = (data) => { // <-- Deve essere 'static'
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/attestati/aggiorna-spedizione`;
      // Assumi che ApiService.postRequest gestisca la chiamata
      ApiService.postRequest(resolve, reject, url, data);
    });
  };
}